// Скачивание blob как файла + разбор имени из заголовка Content-Disposition.

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/** Имя файла из Content-Disposition (поддержка RFC 5987 filename*=UTF-8''… и обычного filename=). */
export function filenameFromContentDisposition(header: string | undefined): string | undefined {
  if (!header) {
    return undefined;
  }
  const star = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].replace(/["']/g, '').trim());
    } catch {
      // падать не должны — попробуем обычный filename ниже
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header);
  return plain?.[1]?.trim();
}
